const baseState = {
    number: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0,
    userPaginationParamsSetted: false,
    sortByField: "",
	sortFromTo: "asc"
}

const userPaginationReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_ALL_PAGINATION_PARAMS": {
			return {
				...state,
				number: payload.number,
			    size: payload.size,
			    totalElements: payload.totalElements,
			    totalPages: payload.totalPages
			}
		}

    	case "SET_PAGE_NUMBER": {
			return {
				...state,
				number: payload
			}
		}

		case "SET_PAGE_SIZE": {
			return {
				...state,
				size: payload
			}
		}

		case "SET_TOTAL_ELEMENTS": {
			return {
				...state,
				totalElements: payload
			}
		}

		case "SET_TOTAL_PAGES": {
			return {
				...state,
				totalPages: payload
			}
		}

		case "SET_USER_PAGINATION_PARAMS": {
			return {
				...state,
				userPaginationParamsSetted: payload
			}
		}

		case "SET_USER_SORT_BY_FIELD": {
			return {
				...state,
				sortByField: payload
			}
		}

		case "SET_USER_SORT_FROM_TO": {
			return {
				...state,
				sortFromTo: payload
			}
		}

        default:
            return state;
    }
}

export default userPaginationReducer